import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M9 3v18","key":"svg-0"}],["path",{"d":"M3 9h18","key":"svg-1"}],["path",{"d":"M3 15h10","key":"svg-2"}],["path",{"d":"M15 3v10","key":"svg-3"}],["path",{"d":"M11 21h-6a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v8","key":"svg-4"}],["path",{"d":"M15 19l2 2l4 -4","key":"svg-5"}]]

const IconFirewallCheck = createReactComponent('outline', 'firewall-check', 'FirewallCheck', __iconNode);

export default IconFirewallCheck;